document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-nav]');

  const closeMenu = () => {
    if (!toggle || !nav) return;
    nav.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Open menu');
  };

  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    });

    nav.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', closeMenu);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeMenu();
    });
  }

  const current = new URL(window.location.href);
  const previewKeys = ['preview_theme_id', 'preview_key', '_fd', 'pb'];

  document.querySelectorAll('a[href^="/"]').forEach((link) => {
    const target = new URL(link.getAttribute('href'), window.location.origin);
    let changed = false;

    previewKeys.forEach((key) => {
      if (current.searchParams.has(key) && !target.searchParams.has(key)) {
        target.searchParams.set(key, current.searchParams.get(key));
        changed = true;
      }
    });

    if (changed) {
      link.href = target.pathname + target.search + target.hash;
    }
  });

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    form.addEventListener('submit', () => {
      const button = form.querySelector('button[type="submit"]');
      if (button) {
        button.disabled = true;
        button.textContent = 'Adding…';
      }
    });
  });
});

window.addEventListener('pageshow', () => {
  document.querySelectorAll('[data-product-form] button[type="submit"]').forEach((button) => {
    if (button.textContent === 'Adding…') {
      button.disabled = false;
      button.textContent = 'Add to cart';
    }
  });
});
